import React, { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Clock, CalendarClock } from "lucide-react";

type Props = {
  sourceName: string;
};

export const AnalysisScheduler = ({ sourceName }: Props) => {
  const [schedule, setSchedule] = useState("none");
  const [customTime, setCustomTime] = useState("09:00");

  const handleSave = () => {
    if (schedule === "none") {
      toast.info("No schedule set.");
      return;
    }
    toast.success(`Scheduled ${schedule} analysis for "${sourceName}" at ${customTime}`);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <CalendarClock className="h-5 w-5 text-primary" />
          Schedule Recurring Analysis
        </CardTitle>
        <CardDescription>
          Automatically re-run AI analysis on "{sourceName}" at a regular interval.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Frequency</Label>
            <Select value={schedule} onValueChange={setSchedule}>
              <SelectTrigger>
                <SelectValue placeholder="Select frequency" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="none">No schedule</SelectItem>
                <SelectItem value="daily">Daily</SelectItem>
                <SelectItem value="weekly">Weekly</SelectItem>
                <SelectItem value="monthly">Monthly</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>Time</Label>
            <div className="flex items-center gap-2">
              <Clock className="h-4 w-4 text-muted-foreground" />
              <Input
                type="time"
                value={customTime}
                onChange={(e) => setCustomTime(e.target.value)}
                disabled={schedule === "none"}
              />
            </div>
          </div>
        </div>
        <Button onClick={handleSave} disabled={schedule === "none"}>
          Save Schedule
        </Button>
      </CardContent>
    </Card>
  );
};
